export default function(){

    /**
     * Sets the browser history and URL params based on active pagination
     * @param page int > 0
     * @param sort string review
     */
    const pushUrlParamsToHistory = ({page, sort}) => {
        let defaults = getUrlParams();
        let p = page ?? defaults.p;
        let ls = sort ?? defaults.ls;
        QS.setValue('p', p, false);
        QS.setValue('ls', ls, false);
        window.history.pushState({p, ls}, '', '?' + QS.toRaw());
    }

    /**
     * Returns the current URL Params, or sensible defaults, for the Page, Sort, and active Tab identifier
     * For browse list
     *
     * @returns {{p: int, ls: 'best|review|resp_time', lt: 'matches|responses'}} P: pageNumber, ls: List Sort, ls: List Tab
     */
    const getUrlParams = () => {
        let p = parseInt(QS.getValue('p', 1));
        if (isNaN(p) || p < 1) {
            p = 1;
        }
        let ls = QS.getValue('ls', '-review');
        return {p, ls};
    }

    const appendUrlParamsToUrl = (urlString) => {
        let url = new URL(urlString);
        let {p,ls} = getUrlParams();
        url.searchParams.append('p', p);
        url.searchParams.append('ls', ls);
        return url;
    }

    const returnUrlQueryString = () => {
        let {p, ls} = getUrlParams();
        return `p=${p}&ls=${ls}`
    }

    return {
        getUrlParams,
        pushUrlParamsToHistory,
        appendUrlParamsToUrl,
        returnUrlQueryString
    }
}
